import styled from 'styled-components'

export const StyledGroudingLabelSection = styled.span`
  font-size: 1.6rem;
  text-align: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.defaultTextColor};

  & a {
    display: contents;
    font-size: 1.8rem;
    font-weight: 600;
    margin-left: 0.5rem;
    color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    &:focus,
    &.focus {
      box-shadow: none;
      text-decoration: none;
    }
  }
  .icon {
    color: ${({ theme }) => theme.carousel.buttonHoverBackground};
    margin-bottom: 0.4rem;
    margin-right: 0.5rem;
  }
  .icon:hover {
    cursor: pointer;
  }
`
export const StyledCountingTextAndIcon = styled.span<{ assetFolder?: string }>`
  color: ${({ theme }) => theme.carousel.buttonHoverBackground};
  /* svg > path {
    fill: ${({ theme }) => theme.carousel.buttonHoverBackground};
  } */
  svg:hover {
    cursor: pointer;
  }
  font-weight: 600;
  font-size: 1.8rem;
`
